import { useState } from "react";
import { AlignLeft, AlignCenter, AlignRight } from "lucide-react";
import FloatingBubble from "../FloatingBubble";
import "./Bubbles.css";

const TYPES = [
  { value: "P", label: "Paragraph" },
  { value: "H1", label: "Heading 1" },
  { value: "H2", label: "Heading 2" },
  { value: "H3", label: "Heading 3" },
  { value: "H4", label: "Heading 4" },
  { value: "BLOCKQUOTE", label: "Quote" },
];

export default function BlockBubble({ anchorEl, iframeEl, onClose, onChange }) {
  const [type, setType] = useState(anchorEl.tagName);
  const [align, setAlign] = useState(anchorEl.style.textAlign || "left");
  const [mt, setMt] = useState(parseInt(anchorEl.style.marginTop) || 0);
  const [mb, setMb] = useState(parseInt(anchorEl.style.marginBottom) || 0);

  const changeType = (newType) => {
    const doc = anchorEl.ownerDocument;
    const replacement = doc.createElement(newType.toLowerCase());
    replacement.innerHTML = anchorEl.innerHTML;
    replacement.style.cssText = anchorEl.style.cssText;
    anchorEl.parentNode.replaceChild(replacement, anchorEl);
    onChange();
    onClose();
  };

  const setAlignCommit = (a) => {
    anchorEl.style.textAlign = a;
    setAlign(a);
    onChange();
  };

  const setMtCommit = (v) => { anchorEl.style.marginTop = `${v}px`; setMt(v); onChange(); };
  const setMbCommit = (v) => { anchorEl.style.marginBottom = `${v}px`; setMb(v); onChange(); };

  return (
    <FloatingBubble anchorEl={anchorEl} iframeEl={iframeEl} label="Block" onClose={onClose}>
      <div className="bubble-field">
        <label>Type</label>
        <select
          value={type}
          onChange={(e) => { setType(e.target.value); changeType(e.target.value); }}
          style={{ height: 30, border: "1px solid #e2e8f0", borderRadius: 6, padding: "0 8px" }}
        >
          {TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </div>
      <div className="bubble-row" style={{ gap: 4 }}>
        <button type="button" className={`bubble-btn icon-only ${align === "left" ? "primary" : ""}`} onClick={() => setAlignCommit("left")}><AlignLeft size={13} /></button>
        <button type="button" className={`bubble-btn icon-only ${align === "center" ? "primary" : ""}`} onClick={() => setAlignCommit("center")}><AlignCenter size={13} /></button>
        <button type="button" className={`bubble-btn icon-only ${align === "right" ? "primary" : ""}`} onClick={() => setAlignCommit("right")}><AlignRight size={13} /></button>
      </div>
      <div className="bubble-row">
        <div className="bubble-field" style={{ flex: 1 }}>
          <label>Margin top</label>
          <input type="number" value={mt} onChange={(e) => setMtCommit(parseInt(e.target.value) || 0)} />
        </div>
        <div className="bubble-field" style={{ flex: 1 }}>
          <label>Margin bottom</label>
          <input type="number" value={mb} onChange={(e) => setMbCommit(parseInt(e.target.value) || 0)} />
        </div>
      </div>
    </FloatingBubble>
  );
}
